import { every } from "lodash";
import { FloatingButton } from "ui";

import useProductFormFormik from "../hooks/useProductFormFormik";

export default function SubmitButton() {
  const {
    values: { name, images, prices },
    isEditing,
    combinationCountExceedsLimit,
    handleSubmit,
    isSubmitting,
  } = useProductFormFormik();

  const validImages = every(images, "url");

  const validPrice = prices.length > 0 && every(prices, "amount");

  const text = getButtonText({
    name,
    isEditing,
    validImages,
    validPrice,
    combinationCountExceedsLimit,
  });

  const disabled =
    !name || !validPrice || !validImages || combinationCountExceedsLimit;

  return (
    <FloatingButton
      text={text}
      loading={isSubmitting}
      disabled={isSubmitting || disabled}
      onPress={handleSubmit}
    />
  );
}

type ButtonTextParams = {
  name: string;
  isEditing: boolean;
  validPrice: boolean;
  validImages: boolean;
  combinationCountExceedsLimit: boolean;
};

function getButtonText({
  name,
  isEditing,
  validPrice,
  validImages,
  combinationCountExceedsLimit,
}: ButtonTextParams) {
  const word = isEditing ? "guardar" : "crear";

  if (!name && !validPrice) {
    return `Agrega nombre y precio para ${word}`;
  } else if (!name) {
    return `Agrega nombre para ${word}`;
  } else if (!validPrice) {
    return `Crea al menos un precio para ${word}`;
  } else if (!validImages) {
    return `Subiendo imágen...`;
  } else if (combinationCountExceedsLimit) {
    return "Limite de combinaciones excedido";
  } else {
    return `${word.charAt(0).toUpperCase()}${word.slice(1)}`;
  }
}
